import { ReactNodeViewRenderer } from '@tiptap/react'

import { FileNode as SharedFileNode } from '~shared/richtext/nodes/file.node'

import { FileNodeViewLive } from './FileNodeView'

/**
 * Extends our custom `FileNode` with client-only features.
 */
export const FileNode = SharedFileNode.extend({
  addNodeView() {
    return ReactNodeViewRenderer(FileNodeViewLive)
  },
})
